"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tld = 'authereum.com';
exports.defaultConfig = {
    xsUri(network) {
        const s = network === 'mainnet' ? '' : `${network}.`;
        return `https://${s}x.${tld}`;
    }
};
